import { render, staticRenderFns } from "./GroupingSkill.vue?vue&type=template&id=2fba9f3d"
import script from "./GroupingSkill.vue?vue&type=script&lang=js"
export * from "./GroupingSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports